import * as React from "react"
import { Card, CardHeader, CardSection } from "gatsby-interface"
import { SiteSettingsSection, SiteSettingsSectionLabel } from "../constants"
import { NotificationDeploys } from "@modules/notifications/deploys/NotificationDeploys"
import { NotificationDeploysTrigger } from "@modules/notifications/deploys/NotificationDeploysTrigger"
import { notificationDeploys as notificationDeploysText } from "@modules/locales/default.json"
import { CloudResourceType } from "@modules/graphql/types"

export type NotificationDeploysSectionProps = {
  siteId: string
}

export function NotificationDeploysSection({
  siteId,
}: NotificationDeploysSectionProps) {
  return (
    <Card id={SiteSettingsSection.NotificationDeploys}>
      <CardHeader
        applyPaddingBottom={false}
        title={
          <React.Fragment>
            {SiteSettingsSectionLabel[SiteSettingsSection.NotificationDeploys]}
          </React.Fragment>
        }
      >
        <NotificationDeploysTrigger
          resourceType={CloudResourceType.Site}
          resourceId={siteId}
        >
          {notificationDeploysText.actions.addNotification}
        </NotificationDeploysTrigger>
      </CardHeader>

      <CardSection>
        <NotificationDeploys
          resourceId={siteId}
          resourceType={CloudResourceType.Site}
        />
      </CardSection>
    </Card>
  )
}
